import { escape } from 'he';
import React, { ElementType } from 'react';
import { FormattedMessage, MessageValue } from 'react-intl';
import { SanitizedHtml } from './sanitized-html';

export type SanitizedFormattedHtmlMessageProps = {
  readonly id: string;

  readonly description?: string;
  readonly defaultMessage?: string;
  readonly values?: { [key: string]: MessageValue };
  readonly tagName?: ElementType;
};

export function SanitizedFormattedHtmlMessage({
  tagName,
  values,
  ...messageDescriptor
}: SanitizedFormattedHtmlMessageProps) {
  return (
    <FormattedMessage
      tagName={tagName}
      values={escapeValues(values)}
      {...messageDescriptor}
    >
      {(html) => {
        return <SanitizedHtml innerHTML={html} tagName={tagName} />;
      }}
    </FormattedMessage>
  );
}

function escapeValues(
  messageValues: { [key: string]: MessageValue | JSX.Element } = {}
): { [key: string]: MessageValue | JSX.Element } {
  Object.keys(messageValues).forEach((keyName) => {
    const messageValue = messageValues[keyName];
    messageValues[keyName] =
      typeof messageValue === 'string' ? escape(messageValue) : messageValue;
  });

  return messageValues;
}
